/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContactCreateDTO } from '../models';
// @ts-ignore
import type { ContactResponseDTO } from '../models';
// @ts-ignore
import type { ContactUpdateDTO } from '../models';
// @ts-ignore
import type { ContactWithHistoryDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageContactResponseDTO } from '../models';
/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactApiV1ContactsPost: async (contactCreateDTO: ContactCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactCreateDTO' is not null or undefined
            assertParamExists('createContactApiV1ContactsPost', 'contactCreateDTO', contactCreateDTO)
            const localVarPath = `/api/v1/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactApiV1ContactsPost_1: async (contactCreateDTO: ContactCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactCreateDTO' is not null or undefined
            assertParamExists('createContactApiV1ContactsPost_1', 'contactCreateDTO', contactCreateDTO)
            const localVarPath = `/api/v1/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactApiV1ContactsContactIdDelete: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContactApiV1ContactsContactIdDelete', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactApiV1ContactsContactIdDelete_2: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContactApiV1ContactsContactIdDelete_2', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactGdprApiV1ContactsContactIdGdprDelete: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContactGdprApiV1ContactsContactIdGdprDelete', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}/gdpr`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactGdprApiV1ContactsContactIdGdprDelete_3: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContactGdprApiV1ContactsContactIdGdprDelete_3', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}/gdpr`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactApiV1ContactsContactIdGet: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContactApiV1ContactsContactIdGet', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactApiV1ContactsContactIdGet_4: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContactApiV1ContactsContactIdGet_4', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByPhoneApiV1ContactsByPhoneGet: async (phoneNumber: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('getContactByPhoneApiV1ContactsByPhoneGet', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/contacts/by-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByPhoneApiV1ContactsByPhoneGet_5: async (phoneNumber: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('getContactByPhoneApiV1ContactsByPhoneGet_5', 'phoneNumber', phoneNumber)
            const localVarPath = `/api/v1/contacts/by-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactWithHistoryApiV1ContactsContactIdHistoryGet: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContactWithHistoryApiV1ContactsContactIdHistoryGet', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}/history`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactWithHistoryApiV1ContactsContactIdHistoryGet_6: async (contactId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContactWithHistoryApiV1ContactsContactIdHistoryGet_6', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}/history`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactsApiV1ContactsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactsApiV1ContactsGet_7: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContactsApiV1ContactsSearchGet: async (firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContactsApiV1ContactsSearchGet_8: async (firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactApiV1ContactsContactIdPatch: async (contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContactApiV1ContactsContactIdPatch', 'contactId', contactId)
            // verify required parameter 'contactUpdateDTO' is not null or undefined
            assertParamExists('updateContactApiV1ContactsContactIdPatch', 'contactUpdateDTO', contactUpdateDTO)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactApiV1ContactsContactIdPatch_9: async (contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContactApiV1ContactsContactIdPatch_9', 'contactId', contactId)
            // verify required parameter 'contactUpdateDTO' is not null or undefined
            assertParamExists('updateContactApiV1ContactsContactIdPatch_9', 'contactUpdateDTO', contactUpdateDTO)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactApiV1ContactsPost(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactApiV1ContactsPost(contactCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.createContactApiV1ContactsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactApiV1ContactsPost_1(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactApiV1ContactsPost_1(contactCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.createContactApiV1ContactsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContactApiV1ContactsContactIdDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContactApiV1ContactsContactIdDelete(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.deleteContactApiV1ContactsContactIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContactApiV1ContactsContactIdDelete_2(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContactApiV1ContactsContactIdDelete_2(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.deleteContactApiV1ContactsContactIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.deleteContactGdprApiV1ContactsContactIdGdprDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.deleteContactGdprApiV1ContactsContactIdGdprDelete_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactApiV1ContactsContactIdGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactApiV1ContactsContactIdGet(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactApiV1ContactsContactIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactApiV1ContactsContactIdGet_4(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactApiV1ContactsContactIdGet_4(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactApiV1ContactsContactIdGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactByPhoneApiV1ContactsByPhoneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactByPhoneApiV1ContactsByPhoneGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactWithHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactWithHistoryApiV1ContactsContactIdHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactWithHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactWithHistoryApiV1ContactsContactIdHistoryGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContactsApiV1ContactsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContactsApiV1ContactsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.listContactsApiV1ContactsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContactsApiV1ContactsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContactsApiV1ContactsGet_7(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.listContactsApiV1ContactsGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContactsApiV1ContactsSearchGet(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContactsApiV1ContactsSearchGet(firstname, lastname, phone, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.searchContactsApiV1ContactsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContactsApiV1ContactsSearchGet_8(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContactsApiV1ContactsSearchGet_8(firstname, lastname, phone, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.searchContactsApiV1ContactsSearchGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactApiV1ContactsContactIdPatch(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactApiV1ContactsContactIdPatch(contactId, contactUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.updateContactApiV1ContactsContactIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactApiV1ContactsContactIdPatch_9(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactApiV1ContactsContactIdPatch_9(contactId, contactUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.updateContactApiV1ContactsContactIdPatch_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactApiV1ContactsPost(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.createContactApiV1ContactsPost(contactCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
         * @summary Create Contact
         * @param {ContactCreateDTO} contactCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactApiV1ContactsPost_1(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.createContactApiV1ContactsPost_1(contactCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactApiV1ContactsContactIdDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContactApiV1ContactsContactIdDelete(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactApiV1ContactsContactIdDelete_2(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContactApiV1ContactsContactIdDelete_2(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
         * @summary Delete Contact Gdpr
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactApiV1ContactsContactIdGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.getContactApiV1ContactsContactIdGet(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact by ID. Requires \'contact:view\' permission.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactApiV1ContactsContactIdGet_4(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.getContactApiV1ContactsContactIdGet_4(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact by exact phone number match. Requires \'contact:view\' permission.
         * @summary Get Contact By Phone
         * @param {string} phoneNumber 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactWithHistoryDTO> {
            return localVarFp.getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
         * @summary Get Contact With History
         * @param {string} contactId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactWithHistoryDTO> {
            return localVarFp.getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactsApiV1ContactsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageContactResponseDTO> {
            return localVarFp.listContactsApiV1ContactsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
         * @summary List Contacts
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactsApiV1ContactsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageContactResponseDTO> {
            return localVarFp.listContactsApiV1ContactsGet_7(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContactsApiV1ContactsSearchGet(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageContactResponseDTO> {
            return localVarFp.searchContactsApiV1ContactsSearchGet(firstname, lastname, phone, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
         * @summary Search Contacts
         * @param {string | null} [firstname] 
         * @param {string | null} [lastname] 
         * @param {string | null} [phone] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContactsApiV1ContactsSearchGet_8(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageContactResponseDTO> {
            return localVarFp.searchContactsApiV1ContactsSearchGet_8(firstname, lastname, phone, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactApiV1ContactsContactIdPatch(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.updateContactApiV1ContactsContactIdPatch(contactId, contactUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateDTO} contactUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactApiV1ContactsContactIdPatch_9(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponseDTO> {
            return localVarFp.updateContactApiV1ContactsContactIdPatch_9(contactId, contactUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
     * @summary Create Contact
     * @param {ContactCreateDTO} contactCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public createContactApiV1ContactsPost(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).createContactApiV1ContactsPost(contactCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new contact or get existing contact by phone number. If the contact already exists, it will be updated with the provided data. Requires \'contact:write\' permission.
     * @summary Create Contact
     * @param {ContactCreateDTO} contactCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public createContactApiV1ContactsPost_1(contactCreateDTO: ContactCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).createContactApiV1ContactsPost_1(contactCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
     * @summary Delete Contact
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public deleteContactApiV1ContactsContactIdDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).deleteContactApiV1ContactsContactIdDelete(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a contact (normal mode).  **What gets deleted:** - Contact record  **What gets preserved:** - Call logs (contact_id set to NULL) - Callbacks (contact_id set to NULL) - Events (contact_id set to NULL) - Transcripts and turns (unaffected)  **GDPR Compliance**: For complete data deletion, use the GDPR-compliant endpoint instead (`DELETE /contacts/{contact_id}/gdpr`).  **Permissions**: Requires `contact:write` permission
     * @summary Delete Contact
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public deleteContactApiV1ContactsContactIdDelete_2(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).deleteContactApiV1ContactsContactIdDelete_2(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
     * @summary Delete Contact Gdpr
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).deleteContactGdprApiV1ContactsContactIdGdprDelete(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GDPR-compliant contact deletion - permanently delete ALL associated data.  **WARNING**: This action is irreversible and deletes all data associated with the contact.  **What gets permanently deleted:** - Contact record - ALL call logs associated with this contact - ALL conversation transcripts and turns (via call log cascade) - ALL additional answers (via call log cascade) - ALL callbacks associated with this contact - ALL calendar events/appointments associated with this contact  **GDPR Compliance**: Use this endpoint to fulfill GDPR \"right to be forgotten\" requests.  **Permissions**: Requires `contact:write` permission  **Audit Logging**: This operation is logged at WARNING level with full deletion counts for compliance audit.  **Returns**: Dictionary with counts of deleted records by type for audit purposes
     * @summary Delete Contact Gdpr
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).deleteContactGdprApiV1ContactsContactIdGdprDelete_3(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact by ID. Requires \'contact:view\' permission.
     * @summary Get Contact
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactApiV1ContactsContactIdGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactApiV1ContactsContactIdGet(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact by ID. Requires \'contact:view\' permission.
     * @summary Get Contact
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactApiV1ContactsContactIdGet_4(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactApiV1ContactsContactIdGet_4(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact by exact phone number match. Requires \'contact:view\' permission.
     * @summary Get Contact By Phone
     * @param {string} phoneNumber 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactByPhoneApiV1ContactsByPhoneGet(phoneNumber, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact by exact phone number match. Requires \'contact:view\' permission.
     * @summary Get Contact By Phone
     * @param {string} phoneNumber 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactByPhoneApiV1ContactsByPhoneGet_5(phoneNumber, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
     * @summary Get Contact With History
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactWithHistoryApiV1ContactsContactIdHistoryGet(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a contact with full interaction history (call logs, callbacks, events). Requires \'contact:view\' permission.
     * @summary Get Contact With History
     * @param {string} contactId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactWithHistoryApiV1ContactsContactIdHistoryGet_6(contactId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
     * @summary List Contacts
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public listContactsApiV1ContactsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).listContactsApiV1ContactsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all contacts in the current user\'s organization. Requires \'contact:view\' permission.
     * @summary List Contacts
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public listContactsApiV1ContactsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).listContactsApiV1ContactsGet_7(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
     * @summary Search Contacts
     * @param {string | null} [firstname] 
     * @param {string | null} [lastname] 
     * @param {string | null} [phone] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public searchContactsApiV1ContactsSearchGet(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).searchContactsApiV1ContactsSearchGet(firstname, lastname, phone, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search contacts by firstname, lastname, and/or phone number (partial matching). All search criteria are combined with OR logic. Requires \'contact:view\' permission.
     * @summary Search Contacts
     * @param {string | null} [firstname] 
     * @param {string | null} [lastname] 
     * @param {string | null} [phone] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public searchContactsApiV1ContactsSearchGet_8(firstname?: string | null, lastname?: string | null, phone?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).searchContactsApiV1ContactsSearchGet_8(firstname, lastname, phone, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
     * @summary Update Contact
     * @param {string} contactId 
     * @param {ContactUpdateDTO} contactUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public updateContactApiV1ContactsContactIdPatch(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).updateContactApiV1ContactsContactIdPatch(contactId, contactUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a contact\'s information. Metadata updates are merged with existing metadata. Requires \'contact:write\' permission.
     * @summary Update Contact
     * @param {string} contactId 
     * @param {ContactUpdateDTO} contactUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public updateContactApiV1ContactsContactIdPatch_9(contactId: string, contactUpdateDTO: ContactUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).updateContactApiV1ContactsContactIdPatch_9(contactId, contactUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

